module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Chapitre Un")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Année 2100")]), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Quartier Général de l’Escouade du Sexe, Vermont, États-Unis")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("«")]), _vm._v(" On l'appelle le Tombeur")]), _vm._v(". Il mesure un mètre quatre-vingt-dix et pèse quatre-vingt-dix kilos de pure séduction. Aucune femme ne peut lui résister. » La voix grave de l’inspecteur Jim McBride résonnait dans la salle de briefing, captant l’attention de la détective Sky Kelley.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Les deux détectives assis à côté de Sky échangèrent des coups de coude en riant à la description de Jim. Leur manque de sérieux face au Tombeur aggrava la colère de Jim. « Vous deux, avez-vous quelque chose d’important à partager avec nous ? »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Gênés, les deux détectives baissèrent la tête et nièrent.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim hocha la tête avec satisfaction, puis fixa Sky d’un regard intense. Ses yeux s’adoucirent légèrement en la regardant, mais les rides habituelles aux coins de sa bouche restaient tendues.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Des cernes marquaient ses yeux, des yeux qui, autrefois, brillaient de désir pour elle. Maintenant, ils n’exprimaient plus que de la douleur.")])]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il détourna rapidement le regard, laissant Sky se sentir mise de côté, comme si elle n’était plus qu’une simple collègue, et non la femme qu’il avait prévu d’épouser, jusqu’à il y a une semaine. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky ferma les yeux un instant pour se ressaisir. Des larmes de regret montèrent à ses yeux. Elle regrettait de ne pas avoir cédé aux demandes de Jim concernant leurs relations sexuelles. Répondre à ce besoin pressant aurait été si simple, mais elle avait préféré attendre le mariage. Malheureusement, elle avait dit non une fois de trop et se retrouvait maintenant seule. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Voici quelques informations sur le Tombeur, » reprit Jim. « Abandonné à la naissance, il a été élevé dans un orphelinat par des religieuses. Destiné à devenir prêtre, il a finalement quitté cette voie. Ces dernières années, le Tombeur a vécu sur Saturna, la nouvelle planète du plaisir située sur l’une des lunes de Saturne. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Des murmures excités parcoururent la salle. Tout le monde connaissait cet avant-poste du sexe. Plusieurs de ses amis avaient mentionné qu’ils ne seraient pas contre un voyage là-bas, dans un endroit où personne ne les connaissait et où ils pourraient se perdre dans un monde de plaisir. Selon les rumeurs, les gens qui s’y promenaient pouvaient être abordés par des inconnus, et seraient alors obligés d’avoir des relations sexuelles avec eux. Incroyable.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim poursuivit : « Il y a quelques mois, une jeune femme a contacté les autorités de Saturna, affirmant avoir été séduite par le Tombeur, puis retenue contre son gré dans une ferme isolée où elle était formée pour devenir esclave. Elle a réussi à s’échapper, mais pas avant d’avoir découvert que le Tombeur formait également d’autres femmes et hommes pour devenir des esclaves sexuels.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Comme vous le savez, en raison de la nécessité pour le gouvernement de trouver de nouvelles sources de revenus, il a investi massivement dans Saturna, qui est devenue une véritable mine d’or. Drogues sexuelles, prostitution et esclaves sexuels y sont légaux. Cependant, éviter de payer les impôts sur les revenus générés par ces activités lucratives est illégal. Le Tombeur n’a pas déclaré ses revenus sur Saturna. Si ce que notre informateur dit est vrai, et que le Tombeur forme des esclaves, il est dans une situation grave pour fraude fiscale, sans parler de l’enlèvement de cette femme. Le chef veut que deux de nos détectives se rendent sur place sous couverture en tant que témoins. L’un d’eux devra être une femme vierge. Une vierge est nécessaire car, d’après les rumeurs, le Tombeur peut les identifier au premier regard. Il ne peut pas leur résister, et elles ne peuvent pas lui résister.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Apparemment, c’est un amant exceptionnel. Une fois qu’une femme a été avec lui, elle devient accro au sexe. Il lui offre ensuite une formation intensive. Lui et une ancienne camarade d’orphelinat, Carmella, sont les seuls instructeurs de sa prétendue école de formation, qui se trouve justement dans la ferme isolée que j’ai mentionnée. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La salle était plongée dans un silence total. Jim avait captivé l’attention de tout le monde.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Notre informateur a découvert que l’esclave est assurée d’obtenir un emploi à la fin de sa formation. Le salaire est de trois cent mille dollars par an, avec une option pour renouveler le contrat à la fin de l’année, selon la volonté des deux parties. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Être payé et s’éclater au lit. Ça semble être une sacrée bonne affaire, » murmura l’un des « rigolos », assez bas pour que Jim ne l’entende pas.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Ça paie mieux que l’Escouade du Sexe, et tu peux avoir des relations sexuelles autant que tu veux, » répondit son collègue avec enthousiasme.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky secoua la tête face à ces commentaires insensibles.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Comment pouvaient-ils plaisanter sur un sujet pareil ? Des innocents se retrouvaient dans une vie de gains faciles, sans attendre de faire l’amour par amour. Était-elle la dernière fille à l’ancienne sur Terre ?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Une inspection minutieuse de la villa personnelle du Tombeur sur la planète n’a rien révélé d’inhabituel. Nous n’avons pas réussi à localiser la ferme présumée utilisée pour la formation. Malheureusement, notre informateur, qui prétendait avoir été enlevé par le Tombeur, a disparu peu après avoir signalé l’incident aux autorités. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un sentiment de regret traversa Sky en pensant à la femme disparue. Le Tombeur devait avoir eu vent de son témoignage aux autorités et l’avoir éliminée d’une manière horrible.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« La victime est la fille unique d’un haut responsable gouvernemental de Saturna. Son père nous a engagés pour la retrouver. Les deux personnes qui accepteront cette mission recevront l’identité de la femme, ainsi qu’un voyage tous frais payés à Saturna. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Des exclamations enthousiastes parcoururent la salle. Jim leva la main pour demander le silence.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Pensez-vous qu’elle soit encore en vie ? » demanda Sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim lui lança un regard glacial qui lui donna des frissons.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Elle est vivante. Elle est probablement en train de se faire former en ce moment même. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Donc, vous pensez qu'elle est à nouveau retenue contre son gré ? » insista-t-elle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Peut-être qu'elle est retournée volontairement pour avoir plus de sexe. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Aucun homme n'a un tel pouvoir sur une femme », murmura Sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Le Tombeur, si », répliqua Jim.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il reporta son attention sur l'assemblée.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« L'autre personne dont nous avons besoin pour cette mission est un détective")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("masculin. Il devra infiltrer le réseau en se faisant passer pour un esclave en quête d'emploi. Il devra aussi surveiller la détective féminine pendant qu'ils chercheront ensemble la fille du fonctionnaire gouvernemental. Puisque la villa a déjà été fouillée, il utilisera probablement la ferme mentionnée ou un autre endroit. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Et si nous ne trouvons pas la femme ? » demanda Sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim la regarda à nouveau et dit d'une voix ferme :")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Dans ce cas, les agents infiltrés devront rester en place et poser des questions sans révéler leur véritable identité. Ils doivent être prêts à participer à la formation des esclaves sexuels. Sans hésitation. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky ouvrit la bouche, stupéfaite. Les murmures excités de ses collègues lui parvenaient à peine tandis que Jim détournait le regard d'elle pour continuer ses instructions. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« La détective féminine devra se rapprocher du Tombeur, et le détective masculin ciblera Carmella. Votre mission est double : premièrement, intégrer la vie du Tombeur pour découvrir s’il entraîne vraiment des esclaves sexuels. Deuxièmement, retrouver la femme disparue et la ramener. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La voix de Jim s'effaçait tandis que Sky examinait la photo de surveillance du Tombeur qui accompagnait les documents qu'ils avaient reçus avant le briefing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle inspira profondément en fixant les yeux perçants du Tombeur, d'un bleu intense rappelant une tempête furieuse. Sombres, menaçants et dangereux. Ses cheveux blonds courts encadraient un visage viril et séduisant, et ses lèvres pulpeuses étaient irrésistiblement tentantes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un frisson de désir parcourut son échine. Était-elle excitée simplement en regardant sa photo ? Peut-être. Ou bien était-ce un besoin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un besoin de rencontrer cet homme et de défier son pouvoir de transformer des vierges innocentes en esclaves sexuels. Elle voulait être celle qui ferait tomber le Tombeur ... tout en espérant ne pas tomber avec lui.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("*****")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene"
  }, [_vm._v("«")]), _vm._v(" Que fais-tu en acceptant")]), _vm._v(" cette mission sur le Tombeur ? » hurla Jim en entrant brusquement dans la salle de conférence où Sky examinait les informations que le Chef lui avait remises après sa décision de se porter volontaire. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lorsqu'elle leva les yeux et croisa son regard furieux, une chaleur intense la traversa. Sa proximité lui permettait de sentir son parfum épicé et la tension palpable. Sa barbe sombre accentuait son charme. Elle regretta soudainement de ne pas avoir cédé à ses avances auparavant.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Une image d'elle blottie dans ses bras puissants lui revint à l'esprit. Elle se souvenait de ses mains massant ses seins frémissants, de sa demande urgente de faire l'amour lors de leur dernier rendez-vous, alors qu’ils s’embrassaient à l’arrière de sa voiture près du lac. Sa proposition l'avait effrayée, et elle lui avait demandé d'arrêter. Il l'avait raccompagnée chez elle, lui annonçant à sa porte qu’il ne pouvait plus attendre. Leur mariage avait été annulé, et il allait poursuivre sa vie sans elle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle avait été abasourdie et dévastée.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Tu ne prendras pas cette mission, c'est clair ? » lança-t-il d'un ton sec. Sa voix tendue ramena Sky à la réalité et à la colère qu'elle ressentait depuis qu'il avait rompu leurs fiançailles.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Ne me dis pas quoi faire, Jim McBride ! Tu as perdu ce droit quand tu as annulé nos fiançailles. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Vraiment ? Et maintenant, tu préfères te faire baiser par le Tombeur plutôt que de faire l'amour avec moi ? »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Peut-être qu'il m'apprendra quelques tours », répliqua-t-elle en le taquinant.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ses yeux s'assombrirent dangereusement. Elle aimait le voir en colère. Cela lui donnait un certain pouvoir sur elle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Le pouvoir de faire tout ce qu'il voulait... mais il n'avait jamais osé.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("D’un geste rapide, Jim l’attrapa par la taille et la souleva de sa chaise. Elle étouffa un cri de surprise alors qu'il l'embrassait avec une intensité brûlante. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sa langue se glissait dans la sienne avec force et exigence, explorant chaque recoin de sa bouche.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Son cœur battait à tout rompre. Ses tétons se durcirent en sentant son torse musclé contre elle. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle se remémorait les moments passés dans ses bras, savourant ses baisers tendres. Elle avait toujours souhaité qu'il soit plus audacieux, et il semblait que son vœu soit enfin exaucé. Ce baiser avait un goût de danger, de désespoir, et une touche de domination. Elle aimait ce nouveau Jim. Elle l'aimait beaucoup, et son corps se pressa contre lui, l'accueillant.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle glissa ses doigts dans ses cheveux brun foncé et lui caressa l’arrière de la tête, le rapprochant davantage. Son parfum enivrant la fascinait, et la chaleur de son corps traversait sa peau, faisant brûler son chemisier fin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ses lèvres avaient un goût sombre, dangereux, et terriblement séduisant. Elle avait envie de le dévorer. Entièrement.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle brûlait d'envie de goûter son torse, de sucer ses tétons durs comme du roc, et de se laisser pénétrer par son sexe puissant, jusqu'à ce qu'il comble sa bouche avide. Ces pensées choquantes firent frémir Sky d'excitation. Mais elle savait qu'elle devrait l'arrêter, comme toutes les autres fois. Pourtant, cette fois-ci, elle n’y arrivait pas. Elle voulait plus de lui. Tellement plus.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ses nerfs étaient à vif. Chaque centimètre de son corps frémissait. Elle avait besoin d'être touchée. D'être goûtée. D'être prise.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Qu'est-ce qui lui arrivait ? Oh, peu importe, tant qu'il continuait d'être audacieux.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un bruit sourd monta de sa gorge. C'était un son sensuel qu'elle n'avait jamais entendu auparavant. Jim l'entendit aussi, car son baiser se fit plus intense. Ses lèvres devinrent plus exigeantes. Dominatrices. Enivrantes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle essaya de rivaliser avec sa force, mais n'y parvint pas. Il la submergeait, l’emmenant dans un tourbillon de sensations inconnues.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sa main droite quitta sa taille et glissa sous son chemisier. En un instant, ses doigts plongèrent sous la dentelle de son soutien-gorge, se dirigeant vers son téton gauche.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il le trouva. Dès qu'il le toucha, un plaisir brûlant envahit son sein. Un besoin intense explosa entre ses cuisses. Il pressa, un pincement ferme. Suffisamment pour remplacer l'excitation par une tendresse ardente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Aussitôt, son toucher cruel se transforma en une caresse semi-rugueuse alors qu'il frottait et roulait son téton entre son pouce et son doigt. Elle haleta face aux sensations nouvelles qui pulsaient en elle. Son autre main se serra plus fort autour de sa taille, la tirant plus près de lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle inspira brusquement lorsque sa main quitta son sein et commença à masser l'autre téton. En quelques instants, ses deux tétons étaient durs et sensibles. Il quitta ses seins, sa main glissant le long de son ventre nu, la faisant frissonner d'anticipation. Ses doigts s'accrochèrent à la ceinture de son pantalon. Un souffle d'air frais caressa ses jambes alors qu'il lui retirait pantalon et sous-vêtements.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il attrapa ses fesses nues, la souleva et la déposa sur la table froide. Rapidement, il fit glisser ses vêtements le long de ses jambes, écartant ses cuisses d’un coup de genou pour se glisser entre elles, pressant son érection contre son sexe exposé et palpitant.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La taille de son renflement la terrifiait. Et l'exaltait !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle inspira profondément en sentant les frissons qui la traversaient. Une chaleur humide s’écoulait entre ses cuisses, la préparant pour lui. Son baiser se fit plus intense, faisant basculer son monde.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un doigt rugueux effleura l’intérieur de sa cuisse. Elle frissonna sous son toucher. C’était si agréable.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il éloigna ses lèvres des siennes et murmura d’une voix rauque à son oreille. « Ne te rends-tu pas compte de ce à quoi tu viens de consentir ? »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Son doigt écarta les replis gonflés de ses lèvres. Il caressa son clitoris et une décharge électrisante la traversa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle le lâcha, inclina la tête en arrière et poussa un cri face à l’intensité de son toucher. Peu lui importait qui entendait. Elle était au-delà de ce souci. Elle avait pénétré un nouveau monde. Un monde dangereux du désir.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Le Tombeur jettera un coup d’œil à ton apparence innocente et te prendra. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La pression de Jim sur son point sensible augmenta. Son toucher devint électrique. Sauvage.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Des spasmes époustouflants pulsèrent en elle, faisant pleurer Sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Est-ce ce que tu veux qu’il te prenne, Sky ? »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Oui ! » murmura-t-elle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ses jambes tremblèrent alors qu’une nouvelle vague d’extase l’assaillait. Ses hanches se soulevaient contre son doigt, suppliant pour plus.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle se cambra sur la table alors qu'un doigt pénétrait son vagin déjà humide. La chaleur brûlante l’enveloppait. Bientôt, un autre doigt le rejoignit, puis un autre encore.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il la comblait agressivement. Sa force masculine entrant et sortant rapidement.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Plus vite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Plus vite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Les vagues de plaisir la submergeaient, incessantes et explosives. La chaleur envahissait son corps, la terrifiant par son intensité.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim continuait à pomper. Ses hanches se déplaçaient encore et encore. Elle ne pouvait pas se contrôler !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quelque chose approchait ! Quelque chose de beau, effrayant et intense. Un plaisir insupportable prenait le contrôle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky ferma les yeux. Son cœur battait fort et elle haletait.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim accéléra ses mouvements. En quelques secondes, une explosion profonde déchira son être.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky cria et frissonna alors que des convulsions l’enveloppaient.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Laisse-toi aller, Sky. Suis le mouvement. » murmura Jim.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle agrippa ses épaules puissantes, enfonçant ses ongles dans ses muscles tendus. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Suis le mouvement, » chuchota Jim.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("C’était insensé. Insupportable. Plaisir. Extase.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Des frissons l’envahirent. Des étoiles brillantes éclatèrent devant ses yeux. Elle ne savait pas combien de temps la frénésie avait duré, mais enfin les spasmes s’atténuèrent. Les respirations de Jim étaient fortes et lourdes à ses oreilles. Ses muscles vaginaux tremblaient autour de ses doigts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle était étourdie. Épuisée. Satisfaite. Magnifiquement comblée.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mon dieu ! C’était fantastique !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle s’accrocha aux épaules massives de Jim jusqu’à ce que la chaleur érotique commence à diminuer. Puis elle desserra son emprise.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Je ne vais pas demander si c’était bien. Cela se lit sur ton visage. On dirait une femme qui a été bien « traitée ». » Sa voix était douce et tendre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Traitée ». La réalité la frappa. Oh mon dieu ! Que lui était-il arrivé ?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle était assise sur une table dans une salle de conférence au milieu du quartier général de l’Escouade du Sexe avec les doigts d’un homme en elle.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Et si quelqu'un entrait ? Avoir des relations sur le lieu de travail était illégal. Ils seraient renvoyés.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Malgré son malaise, elle voulait que les doigts chauds de Jim restent en elle. C’était si agréable. Si complet. Si naturel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Sky, regarde-moi. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle ouvrit les yeux et sa respiration se coupa devant le désir sombre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Le Tombeur va te prendre jusqu’à ce que tu sois aussi désorientée que tu l’étais juste maintenant. Tu vois comme il est facile pour un homme expérimenté de prendre une femme sexuellement innocente comme toi ? Tu vois ? »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Une expression de préoccupation marqua le visage de Jim et le doute s’insinua en elle. Peut-être avait-il raison. Peut-être que cette mission était trop dangereuse. Regardez ce qui venait de lui arriver. Elle avait aimé ce qu'il avait fait. Elle voulait qu'il le fasse à nouveau.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle faillit céder et lui dire qu’elle abandonnerait la mission pour laquelle elle s’était portée volontaire. Presque.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Merci pour ta confiance », répondit-elle, la voix serrée en prenant conscience qu’il cherchait à lui donner une leçon plutôt qu’à la satisfaire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un muscle de sa mâchoire se contracta alors qu’il l’étudiait. Il semblait vraiment se soucier d’elle mais elle était grande. Elle pouvait gérer le Tombeur. Il devait avoir compris qu'elle ne serait pas convaincue par ses arguments, car il jura entre ses dents.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Bon sang, Sky. Ne fais pas ça. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« C’est fait. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Un bruit de succion se fit entendre alors qu’il retirait ses doigts de son vagin trempé.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Je suppose que je me suis trompé sur toi, Sky. Je suis content d’avoir enfin retrouvé mes esprits et de t’avoir laissée. Bonne chance. Tu vas en avoir besoin. »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il se tourna et marcha vers la porte.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Le fils de pute ! S'il ouvrait cette porte, des gens pourraient la voir ainsi !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sky sauta de la table, ses jambes tremblantes presque incapables de la soutenir en touchant le sol.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle attrapa rapidement ses vêtements et se couvrit. Elle voulait céder à Jim. Vouloir qu’il la prenne et la ramène dans le monde du désir sexuel. Maintenant !")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("« Jim ! S'il te plaît, ne pars pas ! »")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La porte s’ouvrit et il était parti, claquant la porte derrière lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Trop tard.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Le mince espoir qu’elle avait de les voir se retrouver était parti avec lui. Essuyant les larmes chaudes coulant sur son visage, elle enfila son sous-vêtement mouillé et se glissa dans son pantalon.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Fixant la porte, Sky redressa les épaules avec défi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim McBride venait de lui donner une leçon qu’elle n’oublierait pas de sitôt. Elle serait sur ses gardes à partir de maintenant.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("*****")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-j"
  }, [_vm._v("J")]), _vm._v("im McBride était accroupi")]), _vm._v(" contre le mur de briques froides des toilettes désertes, son cœur battant la chamade et sa respiration entrecoupée de halètements courts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Merde ! Il aurait dû savoir que c’était une femme extrêmement déterminée. Une fois qu'elle avait pris une décision, rien ne pouvait la faire changer d'avis.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il ne devait pas s'inquiéter pour elle. Le fait qu’elle soit sexuellement inexpérimentée ne signifiait pas qu’elle n’était pas une excellente détective. Dans son métier, elle avait toujours su se débrouiller. Pourtant, une inquiétude persistait. Pourquoi était-il si préoccupé maintenant ? Parce que tout pouvait mal tourner. Elle était vierge, sexuellement inexpérimentée. S’il laissait le Tombeur s’approcher d’elle, il risquait de la perdre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim avait consulté le dossier sur le Tombeur. Cet homme avait pour cible les vierges, il les courtisait, les séduisait, puis les amenait à se soumettre à ses désirs intenses avant de les manipuler à sa guise. Il était manifestement très compétent au lit s'il pouvait transformer une femme innocente en une esclave consentante. Il n’était pas question que Jim laisse la femme qu'il aimait s’engager dans ce chemin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dans un accès de désespoir, il avait trouvé Sky en train d’observer la photo du Tombeur, ses joues rosies et ses grands yeux bleus écarquillés de désir. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Elle était tellement désirable qu’il en avait mal. Il aurait voulu qu’elle soit nue sur le bureau, se tortillant et gémissant alors qu’il la pénétrait. Il aurait voulu l’adorer, marquer son territoire et chasser l’intérêt qu'elle portait au Tombeur.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sa colère brûlante et son commentaire sur l’inconnu lui ayant appris à faire l'amour avaient mis à mal son contrôle habituel. Il l’avait alors saisie et embrassée. Son parfum sucré l’avait envahi, le rendant ivre de désir. Il avait réussi à maîtriser ses propres besoins pour la satisfaire, et elle avait succombé sous son assaut.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il avait été surpris qu'elle lui permette de toucher son sexe. Il était devenu audacieux en glissant ses doigts au-delà de ses lèvres gonflées dans son canal chaud. Bien qu'elle ait été serrée, elle avait été humide de désir et avait accepté ses autres doigts avec une relative aisance. Il avait commencé à la pénétrer, encore et encore. Il avait su exactement quand elle avait perdu le contrôle et cédé au désir qu'il lui offrait. Elle avait écarté les jambes, l’avait agrippé, enfonçant ses ongles dans ses épaules.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim sourit en se remémorant la sensation des ongles de Sky dans sa peau. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’extase avait crispé son joli visage et ses gémissements gutturaux l’avaient poussé à intensifier ses mouvements. Plus fort. Plus vite. Finalement, elle avait crié et atteint l’orgasme, ses muscles vaginaux se contractant autour de ses doigts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il voulait qu’elle réalise ce qu’elle lui avait nié, qu’elle comprenne ce qu’elle manquait. Il avait réussi à la satisfaire, malgré ses propres sentiments conflictuels. Il avait changé son attitude envers le sexe, et il avait vu les étincelles de satisfaction dans ses grands yeux bleus ainsi que la rougeur de gêne sur son visage lorsqu’elle avait réalisé qu’elle avait perdu le contrôle et lui avait accordé sa confiance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jim ferma les yeux en se remémorant ce doux souvenir et appuya sa tête contre le mur de briques froid. Son sexe pulsait toujours de besoin de soulagement.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il pouvait encore goûter le doux baiser de ses lèvres, se souvenir de la chaleur de sa peau brûlante dans sa paume et de la crème chaude sur ses doigts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il aurait voulu retirer ses doigts et glisser son sexe douloureux en elle. Il en avait été très proche, mais il savait que ce serait une erreur.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dès le début de leur relation, elle avait été claire : elle ne se donnerait pas à un homme tant qu'elle n'était pas certaine de l’aimer. Lorsqu’elle lui avait finalement dit qu'elle l’aimait, il était prêt pour le sexe. Mais la semaine dernière, elle avait exprimé son désir d’attendre le mariage pour avoir des relations sexuelles.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Bon sang ! Il avait attendu si longtemps pour être avec elle, et maintenant elle voulait attendre encore plus longtemps ? Elle était frustrante.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il désirait être avec elle, imaginant son visage rougi et ses petits gémissements chaque matin et chaque nuit lorsqu’ils feraient l’amour.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il voulait être le père de ses enfants. S’il obtenait ce qu’il voulait, ils auraient beaucoup d’enfants. Il ne devait pas laisser la mission l’empêcher d’atteindre ses rêves. Jim avala difficilement en réalisant l'idée qui venait de lui traverser l'esprit. Tout à coup, il savait exactement ce qu'il devait faire.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23744bf7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0